export const AuthModalTypes = {
  SIGN_IN: "SignIn",
  SIGN_UP: "SignUp",
  PROVIDE_PASSWORD: "ProvidePassword",
  COMPLETE_PROFILE: "CompleteProfile",
};
